import { NgModule } from '@angular/core'
import { DisplayDatePipe } from './display-date.pipe'

@NgModule({
    declarations: [DisplayDatePipe],
    exports: [DisplayDatePipe],
    providers: [DisplayDatePipe]
})
export class DisplayDatePipeModule {

}